import WpNotification from './wp-notification';

export default class NotificationEventArgs {
    Data: WpNotification

    constructor(data: WpNotification) {
        this.Data = data;
    }
}